import { gql } from '@apollo/client';

export const APPROVE_ALL_TEST_SESSIONS = gql`
  mutation ApproveAllTestSessions($projectId: ID!) {
    approveAllTestSessions(projectId: $projectId) {
      testSession {
        id
        approved
      }
    }
  }
`;
